import { KAPLAYCtx } from "kaplay";
import {
    FLOOR_Y,
    GAME_HEIGHT,
    GAME_WIDTH,
    LASER_HEIGHT,
    LASER_Y,
    SHAFT_CENTER_X,
    SHAFT_LEFT,
    SHAFT_RIGHT,
    SHAFT_WIDTH,
} from "../../constants";
import { PALETTE } from "../../theme";
import { rainbowRgb } from "../../ui/rainbow";

const SHAFT_HEIGHT = FLOOR_Y - LASER_Y;
const WALL_WIDTH = 4;

/** Static backdrop: background, shaft interior, walls and floor. */
export function addShaft(k: KAPLAYCtx): void {
    k.add([k.rect(GAME_WIDTH, GAME_HEIGHT), k.pos(0, 0), k.color(...PALETTE.background), k.z(-10)]);

    k.add([k.rect(SHAFT_WIDTH, SHAFT_HEIGHT), k.pos(SHAFT_LEFT, LASER_Y), k.color(18, 22, 34), k.z(-8)]);

    // Centre guide line
    k.add([
        k.rect(2, SHAFT_HEIGHT),
        k.pos(SHAFT_CENTER_X - 1, LASER_Y),
        k.color(35, 45, 70),
        k.opacity(0.4),
        k.z(-7),
    ]);

    for (const wallX of [SHAFT_LEFT - WALL_WIDTH, SHAFT_RIGHT]) {
        k.add([
            k.rect(WALL_WIDTH, SHAFT_HEIGHT),
            k.pos(wallX, LASER_Y),
            k.color(50, 70, 110),
            k.outline(1, k.rgb(80, 110, 180)),
            k.z(-5),
        ]);
    }

    k.add([
        k.rect(SHAFT_WIDTH + WALL_WIDTH * 2, 8, { radius: 2 }),
        k.pos(SHAFT_LEFT - WALL_WIDTH, FLOOR_Y),
        k.color(60, 80, 120),
        k.outline(2, k.rgb(100, 140, 210)),
        k.z(2),
    ]);
}

/** The deadly rainbow laser across the top of the shaft. */
export function addLaser(k: KAPLAYCtx): void {
    const glow = k.add([
        k.rect(SHAFT_WIDTH, LASER_HEIGHT + 8, { radius: 4 }),
        k.pos(SHAFT_LEFT, LASER_Y - 4),
        k.color(255, 60, 100),
        k.opacity(0.35),
        k.z(4),
    ]);

    const bar = k.add([
        k.rect(SHAFT_WIDTH, LASER_HEIGHT, { radius: 3 }),
        k.pos(SHAFT_LEFT, LASER_Y),
        k.color(255, 50, 80),
        k.outline(2, k.rgb(...PALETTE.white)),
        k.z(5),
    ]);

    bar.onUpdate(() => {
        const color = k.rgb(...rainbowRgb(k.time(), 5));
        bar.color = color;
        glow.color = color;
        glow.opacity = 0.25 + Math.sin(k.time() * 10) * 0.15;
    });

    // k.add([
    //     k.text("▲ RAINBOW LASER HAZARD ▲", textStyle(11)),
    //     k.pos(SHAFT_CENTER_X, LASER_Y - 12),
    //     k.anchor("center"),
    //     k.color(255, 90, 120),
    //     k.z(6),
    // ]);
}
